﻿package org.zq.pixelset.platform

import kotlinx.browser.window

actual fun openExternalUrl(url: String) {
    window.open(url, "_blank")
}
